var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChartScatter = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 2.25C1.5 1.83579 1.16421 1.5 0.75 1.5C0.335786 1.5 0 1.83579 0 2.25V21.75C0 22.1642 0.335786 22.5 0.75 22.5H23.25C23.6642 22.5 24 22.1642 24 21.75C24 21.3358 23.6642 21 23.25 21H1.5V2.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.75C6 15.3358 6.33579 15 6.75 15C7.16421 15 7.5 15.3358 7.5 15.75C7.5 16.1642 7.16421 16.5 6.75 16.5C6.33579 16.5 6 16.1642 6 15.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.75C13.5 12.3358 13.8358 12 14.25 12C14.6642 12 15 12.3358 15 12.75C15 13.1642 14.6642 13.5 14.25 13.5C13.8358 13.5 13.5 13.1642 13.5 12.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.25C7.5 7.83579 7.83579 7.5 8.25 7.5C8.66421 7.5 9 7.83579 9 8.25C9 8.66421 8.66421 9 8.25 9C7.83579 9 7.5 8.66421 7.5 8.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6.75C19.5 6.33579 19.8358 6 20.25 6C20.6642 6 21 6.33579 21 6.75C21 7.16421 20.6642 7.5 20.25 7.5C19.8358 7.5 19.5 7.16421 19.5 6.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.75C18 15.3358 18.3358 15 18.75 15C19.1642 15 19.5 15.3358 19.5 15.75C19.5 16.1642 19.1642 16.5 18.75 16.5C18.3358 16.5 18 16.1642 18 15.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChartScatter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chart-scatter.be331dbd1cd19e4871980c9a44bd05ae.svg";